// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBgColorsOutlinedSvg from "@fishx/icons-svg/es/asn/PBgColorsOutlined";
import FishxIcon from '../components/FishxIcon';

var PBgColorsOutlined = function PBgColorsOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBgColorsOutlinedSvg
  }));
};

PBgColorsOutlined.displayName = 'PBgColorsOutlined';
export default React.forwardRef(PBgColorsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBgColorsOutlined.js
// module id = 3242
// module chunks = 0